(function ($) {
  const HIDE_CLASS = 'is-hidden';
  const AUTO_CLOSE_TIMEOUT_IN_MS = 1000;

  // ---------------------------------------------------------------------------
  //                              SEGMENTS FILTER
  // ---------------------------------------------------------------------------
  const mainContainer = $('.solutions-guide-expo-container');

  if (mainContainer.length === 0) {
    return
  };

  const solutionsGroups = $('.solutions-container__group');
  const solutionsNoData = $('.solutions-container__no-data');
  const form = $('.solutions-filter');
  const multiselect = form.find('.solutions-filter__multiselect');

  let autoCloseTimeout = null;

  multiselect.each((_, element) => {
    const fieldGroup = $(element);
    const label = fieldGroup.find('.solutions-filter__multiselect-label');
    const field = fieldGroup.find('.solutions-filter__multiselect-field');
    const tagList = fieldGroup.find('.solutions-filter__multiselect-tags-list');
    const options = fieldGroup.find('.solutions-filter__multiselect-option input');
    const clearButton = fieldGroup.find('.solutions-filter__multiselect-clear');

    // Open select
    label.on('click', () => { field.addClass('is-open'); });
    tagList.on('click', () => { field.addClass('is-open'); });

    // Close select on click anywhere outside
    $(document).on('click', (event) => {
      const selectContainsTarget = field[0].contains(event.target)
      const selectLabelContainsTarget = label[0].contains(event.target)

      if (!selectContainsTarget && !selectLabelContainsTarget) {
        field.removeClass('is-open');
      }
    })

    // Handle select options
    options.on('change', (event) => {
      const { value: termId, dataset } = event.target;
      const tag = tagList.find(`li[data-id="${termId}"]`);

      if (tag.length) {
        tag.remove();
        return;
      };

      const newTag = createTag(termId, dataset.name);
      tagList.append(newTag);
    });

    // Handle clear filter
    clearButton.on('click', () => {
      options.removeAttr('checked');
      tagList.empty();
      handleFilter();
    });
  });

  // Handle filter on form change
  form.on('change', (event) => {
    event.preventDefault();
    handleFilter();
  });

  // Handle filter by segments
  function handleFilter() {
    handleAutoCloseMultiSelect();

    const selectedSponsors = [];
    const selectedSegments = [];
    let contentShownCount = 0;

    form.serializeArray().forEach(({ name, value }) => {
      if (name === 'segment') selectedSegments.push(value);
      if (name === 'sponsor') selectedSponsors.push(value);
    })

    solutionsGroups.each((_, group) => {
      const sponsorship = group.dataset.sponsorship;
      const segments = group.dataset.segments?.split(',') ?? []

      const isSponsorSelected = selectedSponsors.length === 0 || selectedSponsors.includes(sponsorship);
      const isSegmentSelected = selectedSegments.length === 0 || selectedSegments.some(seg => segments.includes(seg));

      if (isSponsorSelected && isSegmentSelected) {
        group.classList.remove(HIDE_CLASS);
        contentShownCount += 1;

        group.querySelectorAll('.solutions-item').forEach(item => {
          if (selectedSegments.length === 0) {
            item.classList.remove(HIDE_CLASS);
          } else {
            const itemSegments = item.dataset.segments.split(',') ?? []
            const shouldHideItem = !selectedSegments.some(seg => itemSegments.includes(seg))
            item.classList.toggle(HIDE_CLASS, shouldHideItem)
          }
        });
      } else {
        group.classList.add(HIDE_CLASS);
      }

      const hasContentShown = contentShownCount > 0;
      solutionsNoData.toggleClass(HIDE_CLASS, hasContentShown);
    })
  }

  // Auto close multiselect after a time without any change
  function handleAutoCloseMultiSelect() {
    const currentOpenedMultiSelect = form.find('.solutions-filter__multiselect-field.is-open')

    if (autoCloseTimeout) {
      clearTimeout(autoCloseTimeout);
    }

    autoCloseTimeout = setTimeout(() => {
      currentOpenedMultiSelect.removeClass('is-open')
    }, AUTO_CLOSE_TIMEOUT_IN_MS)
  }

  // Create a new tag Element with its attributes
  function createTag(id, text = '') {
    const tag = document.createElement('li');
    tag.classList.add('egr-tag');
    tag.dataset.id = id;
    tag.innerHTML = `<span>${text}</span>`;

    return tag;
  }
})(jQuery);

/**
 * Implementation based on llyv from Wing Kam Wong - @wingkwong
 * Optimizing the performance of YouTube and Vimeo videos
 *
 * @link https://github.com/wingkwong/lazy-load-youtube-videos
*/
(function () {
  const BUTTONS_SVG = {
    youtube: `
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="57" fill="none" viewBox="0 0 80 57">
        <path fill="#282828" d="M78.327 8.745a10.018 10.018 0 0 0-7.073-7.072C65.018 0 40 0 40 0S14.982 0 8.745 1.673a10.018 10.018 0 0 0-7.072 7.072C0 14.982 0 28.001 0 28.001s0 13.02 1.673 19.256a10.018 10.018 0 0 0 7.072 7.073C14.982 56.003 40 56.003 40 56.003s25.018 0 31.254-1.673a10.018 10.018 0 0 0 7.073-7.073C80 41.021 80 28.001 80 28.001s-.007-13.02-1.673-19.256Z"/>
        <path fill="#fff" d="m31.992 40.001 20.784-11.999-20.784-11.998V40Z"/>
      </svg>
    `,
    vimeo: `
      <svg xmlns="http://www.w3.org/2000/svg" width="84" height="48" fill="none" viewBox="0 0 84 48">
        <rect width="84" height="48" fill="#282828" rx="4"/>
        <path fill="#fff" d="M52.5 24a1.5 1.5 0 0 1-.744 1.296l-18 10.5A1.5 1.5 0 0 1 31.5 34.5v-21a1.5 1.5 0 0 1 2.256-1.296l18 10.5A1.5 1.5 0 0 1 52.5 24Z"/>
      </svg>
    `,
  }

  function createThumbnailWithButton(video, platform, thumbnail) {
    // Construct Play Button
    const llyvPlayBtn = document.createElement('div');
    llyvPlayBtn.className = `llyv-play-btn is-${platform}`;
    llyvPlayBtn.innerHTML = BUTTONS_SVG[platform];
    video.appendChild(llyvPlayBtn);

    // Construct thumbnail image
    const img = document.createElement('img');
    img.src = thumbnail;
    img.alt = 'Thumbnail do video institucional da empresa';
    video.appendChild(img);
  }

  const videos = document.querySelectorAll('.llyv');

  for (const video of videos) {
    if (video.dataset.platform === 'youtube') {
      createThumbnailWithButton(video, 'youtube', `https://img.youtube.com/vi/${video.dataset.id}/hqdefault.jpg`)

      // Construct iframe
      video.addEventListener('click', function () {
        const iframe = document.createElement('iframe');
        iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + "?rel=0&showinfo=0&autoplay=1");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");

        while (this.firstChild) {
          this.removeChild(this.firstChild);
        }
        this.appendChild(iframe);
      });
    }

    if (video.dataset.platform === 'vimeo') {
      fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${video.dataset.id}&responsive=true`)
        .then(res => res.json())
        .then(data => {
          createThumbnailWithButton(video, 'vimeo', data.thumbnail_url)

          // Construct iframe
          video.addEventListener('click', function () {
            video.classList.add('no-ratio-box');

            while (this.firstChild) {
              this.removeChild(this.firstChild);
            }
            this.insertAdjacentHTML('beforeend', data.html);
          });
        })
        .catch(() => video.innerHTML('<p>Falha ao carregar o video.<p>'))
    }
  }
}());
